// extracted by mini-css-extract-plugin
export default {"termsForm":"Terms_termsForm__irbJy","terms-check-all":"Terms_terms-check-all__WdOyz"};